<mat-progress-bar
	mode="indeterminate"
	*ngIf="!isDataLoaded"
	class="sdp-progress-bar"
></mat-progress-bar>
<h2>
	{{ "applications.title" | translate }}
</h2>
<div class="sdp-section-header-description">
	{{ "applications.info.block.1" | translate }}.
	<div class="sdp-button-create-container-no-card">
		<div
			matTooltip="{{ 'applications.info.maximum.applications.created' | translate }}"
			[matTooltipPosition]="'above'"
			[matTooltipDisabled]="!showApplicationsAtCapacityMessage()"
		>
			<button
				mat-raised-button
				color="primary"
				(click)="createDialog()"
				class="sdp-button-create"
				[disabled]="addDisabled()"
			>{{ "applications.add.text" | translate }}</button>
		</div>
	</div>
</div>
<h3>
	{{ "applications.webapps" | translate }}
</h3>
<mat-card class="sdp-administrative-table-card">
	<sdp-generic-table
		[columnSchema]="webSchema"
		[tableName]="'Web Applications'"
		[tableData]="webapps"
		[rows]="5"
	></sdp-generic-table>
</mat-card>
<div class="sdp-clear"></div>
<h3>
	{{ "applications.otherapps" | translate }}
</h3>
<mat-card class="sdp-administrative-table-card">
	<sdp-generic-table
		[columnSchema]="otherSchema"
		[tableName]="'Other Applications'"
		[tableData]="otherApps"
		[rows]="5"
	></sdp-generic-table>
</mat-card>